import { HeatMapMetrics } from "./HeatMapMetrics";

export default HeatMapMetrics;
